import {transMetaboApi} from "@/axios";

// 查询项目共享人列表
export function listProjectSharerTransMetabo(projectId) {
    return transMetaboApi({
        url: '/projects/share/list/' + projectId,
        method: 'get',
    })
}

// 删除项目共享人
export function delProjectSharerTransMetabo(data) {
    return transMetaboApi({
        url: '/projects/share/remove',
        method: 'post',
        data: data
    })
}

export function addProjectSharerTransMetabo(data) {
    return transMetaboApi({
        url: '/projects/share/add',
        method: 'post',
        data: data
    })
}
